import React from "react";
import AuthProvider from "../AuthProvider";
import MessageProvider from "../MessageProvider";
import ResponsiveMedia from "../ResponsiveMedia";
import Theme from "../Theme";
import Router from "./Router";
import Content from "../Content";

const App = () => {
  const isIE = /*@cc_on!@*/ false || !!document.documentMode;

  return (
    <>
      {isIE ? (
        <Content>
          <p>
            Internet Explorer is not a supported browser for this application.
            We recommend using one of these browsers:
          </p>
          <ul>
            <li>
              <a href="https://www.google.com/chrome/">Chrome</a>
            </li>
            <li>
              <a href="https://www.mozilla.org/firefox/">Firefox</a>
            </li>
            <li>
              <a href="https://www.apple.com/safari/">Safari</a>
            </li>
          </ul>
        </Content>
      ) : (
        <AuthProvider>
          <Theme>
            <ResponsiveMedia>
              <MessageProvider>
                <Router />
              </MessageProvider>
            </ResponsiveMedia>
          </Theme>
        </AuthProvider>
      )}
    </>
  );
};

export default App;
